var map = {
	"./en/2-1/rewards.png": 63306,
	"./fi/2-1/rewards.png": 17180,
	"./in/2-1/rewards.png": 16454,
	"./th/2-1/rewards.png": 77835,
	"./tw/2-1/rewards.png": 28300,
	"./zh/2-1/rewards.png": 22141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29364;